import styled, { css } from "styled-components";
import {
  Colors,
  GrayColors,
  SolutionColors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

export const StyledAutomationCardWrapper = styled.div``;

export const StyledWarningInfo = styled.div`
  display: flex;
  margin-top: 20px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${Colors.dwRed};
  border-radius: 8px;
  background-color: ${Colors.dwRed};
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;

  svg {
    margin-right: 5px;
  }
`;

export const StyledAutomationCard = styled.div<{
  hasError?: boolean;
  isPermitted?: boolean;
}>`
  margin: 9px 30px 14px 30px;
  position: relative;
  padding-top: 5px;
  background-color: #ffffff;
  color: #878b92;
  border-radius: 12px;
  border: 1px solid ${GrayColors["G-1-5"]};
  transition: box-shadow 100ms ease-in;
  text-align: left;
  box-sizing: border-box;
  cursor: pointer;

  transition: border-color 200ms ease;

  ${({ isPermitted }) =>
    isPermitted
      ? ""
      : css`
          pointer-events: none;
          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: ${GrayColors["G-1"]};
            opacity: 0.7;
            z-index: 100;
            border-radius: 12px;
          }
        `}

  ${({ hasError }) =>
    hasError
      ? css`
          border-color: ${SolutionColors.darkPrimaryRed};
        `
      : ""}

  &:hover {
    border-color: ${SolutionColorVariables.sc1};
  }

  .icon-text-button {
    padding: 0;
  }

  .unhover-controls {
    display: block;
  }

  .hover-controls {
    display: none;
  }

  .hover-dots {
    opacity: 0;
    transition: opacity 200ms ease;
  }

  &:hover {
    .hover-controls {
      display: flex;
    }

    .hover-dots {
      opacity: 1;
    }

    .unhover-controls {
      display: none;
    }
  }
`;

export const StyledAutomationCardHead = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  padding: 0 20px;
  position: relative;
`;

export const StyledAutomationCardContent = styled.div`
  font-size: 18px;
  line-height: 25px;
  font-weight: 400;
  cursor: pointer;

  &:hover {
    color: ${Colors.custom15};
  }
`;

export const ErrorWrapper = styled.div`
  font-size: 0.7em;
  display: flex;
  flex-direction: row;
  z-index: 101;
`;

export const StyledAutomationCardError = styled.div`
  margin-left: 10px;
  color: red;
`;

export const StyledAutomationCardControls = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledDotWrapper = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 13px;
  right: 71px;

  &.hover-dots {
    ${({ isOpen }) =>
      isOpen
        ? css`
            opacity: 1;
          `
        : ""}
  }
`;

export const StyledSwitchWrapper = styled.div`
  position: absolute;
  display: flex;
  top: 16px;
  right: 20px;
`;

export const StyledErrorMessageLabel = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: -8px;
  left: -1px;
  min-width: 387px;
  height: 23px;
  background-color: ${SolutionColors.darkPrimaryRed};
  border-radius: 10px;
  padding: 3px 7px;
  color: ${TextColorNames.white};
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  z-index: 4;

  .icon {
    margin-right: 6px;
  }
`;

export const DescriptionContainer = styled.div`
  background-color: #fafafa;
  padding: 10px 20px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;
